import { fgColumnEntries } from "@redotech/redo-fulfillment-common/views/fulfillment/fg-column-catalog";
import {
  FulfillmentGroupData,
  getSelectedRate,
} from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import {
  RedoTablePaddedCell,
  RedoTableTextCell,
} from "@redotech/redo-web/arbiter-components/tables/redo-table-cells";
import { SkeletonText } from "@redotech/redo-web/skeleton";
import { ColumnAlignment } from "@redotech/redo-web/table";
import { Column2 } from "@redotech/redo-web/table2";

const catalogEntry = fgColumnEntries["usps-zone"];

export const USPSZoneColumn: Column2<FulfillmentGroupData> = {
  key: catalogEntry.key,
  title: catalogEntry.title,
  alignment: ColumnAlignment.LEFT,
  renderNormalCell: ({ row }) => {
    if (row.ratesPendingSince) {
      return (
        <RedoTablePaddedCell>
          <SkeletonText length={8} />
        </RedoTablePaddedCell>
      );
    }

    const rate = getSelectedRate({
      selectedShippingRate: row.selectedShippingRate,
      availableRates: row.availableShipmentRates?.rates,
    });

    return (
      <RedoTableTextCell
        text={
          rate?.usps_zone && rate.usps_zone > 0
            ? String(rate.usps_zone)
            : "Unknown"
        }
      />
    );
  },
  onClick: (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
  },
  width: catalogEntry.defaultWidth,
  hidden: true,
};
